module.exports = __webpack_public_path__ + "static/media/appstore.e081eba7.svg";